/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { compose } from 'redux';
import { object, string } from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { Button } from '@material-ui/core';

const styles = (theme) => {
    const {
        palette,
        breakpoints: { maxWidth },
    } = theme;
    return {
        showNowButtonWrapper: {
            '&.showNowButton': {
                width: '50%',
                textTransform: 'uppercase',
                borderRadius: '0',
                padding: '0.5rem 1rem',
                fontSize: '1.25rem',
                lineHeight: '1.5',
                backgroundColor: palette.colorPrimary,
                fontWeight: 700,
                marginTop: '1rem',
                marginBottom: '1rem',
                [theme.breakpoints.down(maxWidth.small_medium_down)]: {
                    width: '100%',
                },
            },
        },
    };
};

const ShopNowButton = (props) => {
    const { slug = '', classes } = props;
    return (
        <div>
            <Button
                href={`/p${slug}`}
                className={`rounded-0 btn btn-primary text-uppercase mb-3 mt-3 btn btn-primary btn-lg btn-block ${classes.showNowButtonWrapper} showNowButton`}
                aria-label="Shop Now"
            >
                Shop Now
            </Button>
        </div>
    );
};

ShopNowButton.propTypes = {
    slug: string.isRequired,
    classes: object.isRequired,
};

export default compose(withStyles(styles))(ShopNowButton);
